import React from 'react'
import classNames from 'classnames'
import { array, string } from 'prop-types'
import './index.scss'

const BlockClickTooltipped = ({ conditions, children, className, tooltipPositionClassname }) => {
  const firstBlockedCondition = conditions.find(element => element.isBlocked)

  const tooltipClassNames = classNames('BlockClickTooltip tooltipped tooltipped-multiline', className, {
    [tooltipPositionClassname]: tooltipPositionClassname,
  })

  return firstBlockedCondition?.isBlocked ? (
    <span className={tooltipClassNames} aria-label={firstBlockedCondition?.message}>
      {children(firstBlockedCondition?.isBlocked)}
    </span>
  ) : (
    children(firstBlockedCondition?.isBlocked)
  )
}

BlockClickTooltipped.propTypes = {
  isClickBlocked: array,
  tooltipPositionClassname: string,
}

BlockClickTooltipped.defaultProps = {
  isClickBlocked: [],
  tooltipPositionClassname: 'tooltipped-n',
}

export default BlockClickTooltipped
